import { render, staticRenderFns } from "./SaleTaxRates.vue?vue&type=template&id=28dc907a&"
import script from "./SaleTaxRates.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports